import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import LazyLoad from 'vanilla-lazyload';

import 'jquery-hoverintent';
import 'scrolltofixed';

import OneDrawer from '@/modules/module-oneDrawer';
import OneSubscribe from '@/modules/module-oneSubscribe';
import OneCookieBanner from '@/modules/module-oneCookieBanner';
import OneMarketing from '@/modules/module-oneMarketing';
import OnePredictiveSearch from '@/modules/module-onePredictiveSearch';
import OnePredictiveSearchBar from '@/modules/module-onePredictiveSearchBar';
import OneCart from '@/modules/module-oneCart';
import OneGWP from '@/modules/module-oneGWP';
import { PUB_SUB_EVENTS, subscribe } from '@/lib/pubsub';
import { getRequest } from '@/service/requests';
import Splide from '@splidejs/splide';
import '@splidejs/splide/css/core';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import { getLocalStorageWithExpiry, setLocalStorageWithExpiry } from '@/utils';
import RechargeGateway from '@/gateway/Recharge';

import '../../styles/modules/oneMobileMenu.scss';

const settings = JSON.parse(window.localStorage.getItem('fob-settings'));

export default Backbone.View.extend({
  initialize: async function (opts) {
    console.log('init global');

    var self = this;
    self.$body = self.$el;
    self.$header = $('header.site-header');
    self.$footer = $('footer.site-footer');
    self.$miniCart = $('#MiniCart');
    self.$mobileNav = $('#MobileNav');
    self.$searchBar = $('#SearchBar');
    self.$mobileSearchBar = $('.mobile-search-bar');
    self.$promoBanner = self.$header.find('.slider-promo-banner');
    self.$promoDrawer = $('#PromoDrawer');
    self.$navi = self.$header.find('nav');
    self.$menuToggle = self.$header.find('.menu-toggle');

    self.searchInlineMode = false;
    self.useSlideInMenuForLevel2 = false;

    // Critical initializations (needed for immediate UI functionality)
    self.initLazyImages(); // Images should lazy load as soon as possible
    self.initCookieBanner(); // Crucial for compliance
    self.initFixedHeader(); // Affects header behavior immediately

    // Defer less critical initializations
    // Use requestAnimationFrame for UI-related initializations for smoother rendering
    requestAnimationFrame(() => {
      self.initSliderPromoBanner();
      self.initNavi();
      self.initUtilities();
      self.initSearch();
      self.initMobileSearchControls();
      self.initPredictiveSearch();
      self.initPredictiveSearchBar();
      self.initMobileMenu();
      self.initSubscirbe();
      self.initFooter();
      self.devTools();
      self.initMiniCart(); // MiniCart updates might not be critical on initial load
    });

    await self.handleRegionRestrictedAccess();

    if (ORW.enableGTM) {
      setTimeout(() => {
        ORW.marketing = ORW.marketing || new OneMarketing();
        ORW.marketing.initPromoWatchers();
        ORW.marketing.initWishlistWatcher();
      }, 0); // Defer to avoid blocking
    }

    if (ORW.GWP.enable == `true`) {
      setTimeout(() => {
        OneGWP.init();
      }, 0); // Defer to avoid blocking
    }
  },

  events: {
    'drawer-opt': 'bodyClassCtl',
    'menu-opt-in': 'bodyClassCtl',
    'menu-opt-out': 'bodyClassCtl'
  },

  bodyClassCtl: function (e) {
    // Please prevent operation on more then one drawer at the same time
    var self = this;
    var type = e.type;
    if (type == 'drawer-opt') {
      self.$body.toggleClass('drawer-opt');
      self.$body.toggleClass('show-overlay');
    } else {
      if (type == 'menu-opt-in') {
        self.$body.addClass('show-overlay');
      } else if (type == 'menu-opt-out') {
        self.$body.removeClass('show-overlay');
      }
    }
  },

  initLazyImages: function () {
    window.ORW.lazyload = new LazyLoad({ threshold: 0 });

    const events = {
      'mouseenter .product-image-wrapper'(e) {
        $(e.currentTarget).find('.product-image.alt').removeClass('hide');
      }
    };

    _.extend(this.events, events);
    this.delegateEvents();
  },

  initSliderPromoBanner: function () {
    var self = this;

    self.checkCustomBannerByChannelParam();

    if (self.$promoBanner.length > 0) {
      if (
        !ORW.utilities.getCookie('promo_banner') &&
        (self.$body.hasClass('template-index') ||
          self.$body.hasClass('template-collection'))
      ) {
        self.$body.addClass('promo-banner-active');
      }

      const sliderType = self.$promoBanner.attr('slide_type');
      console.log('slider type ', sliderType);

      const splideSettings = {
        slide: {
          type: 'loop',
          perPage: 1,
          arrows: false,
          height: '38px',
          pagination: false,
          autoplay: true,
          arrowPath: `M28.2508 34.15L27.4508 33.4L36.3508 24.5H9.55078V23.4H36.3508L27.4508 14.5L28.2508 13.75L38.4508 23.95L28.2508 34.15Z`
        },
        scroll: {
          type: 'loop',
          drag: 'free',
          focus: 'center',
          perPage: 3,
          arrows: false,
          height: '38px',
          pagination: false,
          arrowPath: `M28.2508 34.15L27.4508 33.4L36.3508 24.5H9.55078V23.4H36.3508L27.4508 14.5L28.2508 13.75L38.4508 23.95L28.2508 34.15Z`,
          autoScroll: {
            speed: 1
          }
        }
      };

      const settings = splideSettings[sliderType] ?? splideSettings.slide;

      const slider = new Splide('#slider-promo-banner', settings);
      if (sliderType === 'scroll') slider.mount({ AutoScroll });
      else slider.mount();

      var promoDrawerInit = function () {
        console.log('init promo drawer');
        return OneDrawer.init({
          drawerElem: '#' + self.$promoDrawer.attr('id'),
          triggerEvent: 'click',
          triggerElem: 'header .promo-banner-slide',
          initCallback: function () {},
          openCallback: function () {
            $('header.site-header').addClass('promo-drawer-open');
          },
          closeCallback: function () {
            $('header.site-header').removeClass('promo-drawer-open');
          },
          events: {}
        });
      };

      self.promoDrawerCtl = promoDrawerInit();
    }
  },

  checkCustomBannerByChannelParam: function () {
    const promoBannerStore = 'fobBanner';
    const localBannerValue = getLocalStorageWithExpiry(promoBannerStore);

    const urlParams = new URLSearchParams(window.location.search);
    const promoFromUrl = urlParams.get('promo');

    let promoValue = null;
    if (promoFromUrl) {
      setLocalStorageWithExpiry(
        promoBannerStore,
        promoFromUrl,
        24 * 60 * 60 * 1000
      );

      promoValue = promoFromUrl;
    } else {
      promoValue = localBannerValue;
    }

    const deleteBanners = [];
    const allPromoBannersOnSlide = document.querySelectorAll(
      '.promo-banner-slide'
    );

    if (!promoValue) {
      allPromoBannersOnSlide.forEach((elm) => {
        const channel = elm.getAttribute('main_chanel');
        if (channel) {
          deleteBanners.push(elm);
        }
      });

      deleteBanners.forEach((element) => {
        if (element) {
          // Ensure the element exists
          element.remove();
        }
      });
      return;
    }

    allPromoBannersOnSlide.forEach((elm) => {
      const channel = elm.getAttribute('main_chanel');

      if (!channel || channel !== promoValue) {
        deleteBanners.push(elm);
        return;
      }
    });
    deleteBanners.forEach((element) => {
      if (element) {
        // Ensure the element exists
        element.remove();
      }
    });
  },

  initCookieBanner: function () {
    var self = this;
    if ($('.cookie-banner').length) {
      ORW.cookieBanner = OneCookieBanner.init({
        el: $('.cookie-banner')
      });
    }
  },

  initFixedHeader: function () {
    var self = this;
    self.$header.scrollToFixed({
      dontSetWidth: true
    });
  },

  initNavi: function () {
    var self = this;

    var links = document.links; // open external links in new tabs
    for (let i = 0, linksLength = links.length; i < linksLength; i++) {
      if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
      }
    }

    self.$rawNav = self.$navi.clone();

    // Build mobile Nav
    var $slideInMenu = $('<div class="slide-in-menu"></div>');
    var $clonedNavi = self.$navi.clone();
    _.each($clonedNavi.find('.has-dropdown'), function (child) {
      var $child = $(child);
      var $dropdown = $child.find('menu-component');

      if (self.useSlideInMenuForLevel2) {
        $dropdown.appendTo($slideInMenu);
        $child.find('menu-component').remove();
      } else {
        $dropdown.appendTo($child);
        $child.find('.dropdown-wrapper').remove();
        $child.find('.nav-link').removeAttr('data-trigger');
        $child.addClass('expandable');
      }
    });

    if (self.useSlideInMenuForLevel2) {
      $slideInMenu.appendTo($clonedNavi);
    }
    console.log('kkkkkkkk ', $clonedNavi);
    self.$mobileNav.find('.header-utilities').before($clonedNavi);

    // Build desktop nav
  },

  initUtilities: function () {
    const self = this;

    if (self.isMobile()) return; // Skip hover logic on mobile

    window.__showMenuOverlay = function () {
      self.$body.addClass('show-overlay');
      self.$header.find('.has-dropdown').addClass('active');
      self.$header.find('.level-2.has-children').addClass('active');
    };

    // Force-hide overlay manually (optional)
    window.__hideMenuOverlay = function () {
      self.$body.removeClass('show-overlay');
      self.$header.find('.has-dropdown').removeClass('active');
      self.$header.find('.level-2.has-children').removeClass('active');
    };

    // Show overlay when hovering over the header
    self.$header
      .on('mouseenter', function () {
        self.$body.addClass('show-overlay');
      })
      .on('mouseleave', function () {
        self.$body.removeClass('show-overlay');
      });

    // Hover to show top-level dropdowns
    self.$header
      .find('.has-dropdown:not(.block-search)')
      .on('mouseenter', function () {
        $(this).addClass('active');
        $(this)
          .find('.level-2.has-children.expandable')
          .first()
          .addClass('active');
      })
      .on('mouseleave', function () {
        $(this).removeClass('active');
      });

    // Hover to show level-2 submenus
    self.$header
      .find('.level-2.has-children')
      .on('mouseenter', function () {
        $(this).addClass('active').siblings().removeClass('active');
      })
      .on('mouseleave', function () {
        $(this).removeClass('active');
      });

    // Copy extra links to mobile nav
    const $extraLinkContainer = self.$header.find('.header-extra-links');
    if ($extraLinkContainer.length) {
      const clonedLinks = $extraLinkContainer.clone();
      self.$mobileNav.find('.header-utilities').prepend(clonedLinks.html());
    }
  },
  initSearch: function () {
    var self = this;
    if (self.searchInlineMode) {
      self.$header.hoverIntent({
        over: function () {
          var $target = $(this).find('.block-content');
          $target.on('transitionend', function () {
            $target.off('transitionend');
            setTimeout(function () {
              $target.find('input').focus();
            }, 100);
          });
          $(this).addClass('active');
        },
        out: function () {
          $(this).removeClass('active');
        },
        sensitivity: 100,
        selector: '.block-search'
      });
    } else {
      self.searchCtl = OneDrawer.init({
        drawerElem: '#' + self.$searchBar.attr('id'),
        triggerEvent: 'click',
        triggerElem: 'header .search-toggle',
        openCallback: function () {
          self.$body.addClass('desktop-search-active');
          setTimeout(function () {
            self.$searchBar.find('input').focus();
          }, 100);
        },
        closeCallback: function () {
          self.$body.removeClass('desktop-search-active');
        },
        events: {
          'click .search-form button': function (e) {
            e.preventDefault();
            var $form = $(e.currentTarget).parent('form');
            if ($form.find('input').val()) {
              this.closeDrawer();
              $form.submit();
            } else {
              // May be show error message ...
            }
          }
        }
      });
    }
  },

  initPredictiveSearch: function () {
    var self = this;
    if ($('.predictive-search-form').length) {
      ORW.predictiveSearchModal = OnePredictiveSearch.init({
        el: $('.predictive-search-form')
      });
    }
  },

  initPredictiveSearchBar: function () {
    var self = this;
    if ($('.predictive-search-bar-form').length) {
      ORW.predictiveSearchModal = OnePredictiveSearchBar.init({
        el: $('.predictive-search-bar-form')
      });
    }
  },

  initMobileSearchControls: function () {
    var self = this;

    var $searchOpen = self.$mobileNav.find('.search-open');
    var $searchClose = self.$mobileSearchBar.find('.search-close');
    var $predictiveSearchContainer = self.$mobileNav.find('#predictive-search');

    var $headerUtilites = self.$mobileNav.find('.header-utilities');

    $searchOpen.on('click', function () {
      console.log('===== opeeennnnn');
      self.$mobileSearchBar.removeClass('hidden');
      $predictiveSearchContainer.removeClass('hidden');
      $('html').addClass('overflow-hidden');
      self.$mobileNav.addClass('overflow-hidden');
      $headerUtilites.addClass('search-open');
    });
    $searchClose.on('click', function () {
      self.$mobileSearchBar.addClass('hidden');
      $predictiveSearchContainer.addClass('hidden');
      $('html').removeClass('overflow-hidden');
      self.$mobileNav.removeClass('overflow-hidden');
      $('.predictive-search-bar--search-template').empty();
      $('input#SearchMobile').val('');
      $('.predictive-search-bar-form').removeClass('input-active');
      $headerUtilites.removeClass('search-open');
    });

    $predictiveSearchContainer.on('touchstart', function (e) {
      document.activeElement.blur(); // hide keyboard when trying to see the results
    });
  },

  initMobileMenu: function () {
    var self = this;

    var $predictiveSearchContainer = self.$mobileNav.find('#predictive-search');
    var $headerUtilites = self.$mobileNav.find('.header-utilities');

    self.mobileMenuCtl = OneDrawer.init({
      drawerElem: '#' + self.$mobileNav.attr('id'),
      triggerEvent: 'click',
      triggerElem: 'header .menu-toggle',
      openCallback: function (e) {
        console.log('Aqui se abre =====');
        self.$menuToggle.find('.animated-hamburger').addClass('open');
      },
      closeCallback: function (e) {
        console.log('Aqui se cierra =====');
        self.$menuToggle.find('.animated-hamburger').removeClass('open');
        self.$mobileSearchBar.addClass('hidden');
        $('.predictive-search-bar--search-template').empty();
        $('input#SearchMobile').val('');
        $('.predictive-search-bar-form').removeClass('input-active');
        $predictiveSearchContainer.addClass('hidden');
        $('html').removeClass('overflow-hidden');
        self.$mobileNav.removeClass('overflow-hidden');
        $headerUtilites.removeClass('search-open');
      }
    });

    self.$mobileNav.find('menu-component').hide();
    self.$mobileNav
      .find('menu-component[default-option]')
      .addClass('active')
      .show();

    // Handle expandable toggle manually
    self.$mobileNav.on('click', '.expandable > .nav-link', function (e) {
      console.log('click expandable 00000000');
      e.preventDefault();

      const $parent = $(this).closest('.expandable');

      const $menuComponent = $parent.find('menu-component');
      const isActive = $menuComponent.hasClass('active');

      if (isActive) {
        $menuComponent
          .removeClass('active')
          .stop(true, true)
          .slideUp(300, function () {
            $(this).hide(); // Ensure it's hidden after animation
          });
      } else {
        $menuComponent
          .stop(true, true)
          .hide() // Ensure starting from hidden state
          .slideDown(300, function () {
            $(this).addClass('active'); // Activate after animation
          });
      }

      console.log('menuComponent 000000', $menuComponent);

      $parent.siblings('.expandable.active').removeClass('active');
      $parent.toggleClass('active');
    });
  },

  initMiniCart: function () {
    var self = this;

    $('.add-to-cart-form').off('submit');

    const miniCartElem = document.querySelector('#CartContainer form.cart');
    if (miniCartElem) {
      new OneCart({ el: miniCartElem });
    }

    self.unsubscribeMiniCart = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      async (data) => {
        const cart = await getRequest('/cart.js').then((res) => res.data);
        document.querySelectorAll('.minicart-count').forEach((el) => {
          el.innerHTML = cart.item_count;
        });

        if (window.location.pathname === '/cart') {
          var cartPageForm = document.querySelector('#MainContent form.cart');
          if (cart.item_count === 0) {
            cartPageForm.classList.add('cart-empty');
          } else {
            cartPageForm.classList.remove('cart-empty');
          }
          return;
        }
      }
    );
  },

  initSubscirbe: function () {
    var self = this;
    if ($('.subscribe-modal').length) {
      ORW.subscribeModal = OneSubscribe.init({
        el: $('.subscribe-modal')
      });
    }
  },

  initFooter: function () {
    var self = this;
    var events = {
      'click footer.site-footer .expandable': function (e) {
        if (self.isMobile()) {
          var $curr = $(e.currentTarget);
          var $activeSiblings = $curr.siblings('.expandable.active');
          if ($activeSiblings.length) {
            $activeSiblings.removeClass('active');
          }
          $curr.toggleClass('active');
        }
      }
    };
    _.extend(self.events, events);
    self.delegateEvents();
  },

  isMobile: function () {
    if (ORW.responsive == 'small') {
      return true;
    }
    return false;
  },

  devTools: function () {
    var self = this;
    var $indicator = $('#responsive-indicator');
    var $previewBar = $('#preview-bar-iframe');

    // This should only run when a theme is being previewed.
    if (Shopify.PreviewBarInjector !== undefined) {
      if (
        $indicator.length > 0 &&
        $previewBar.length > 0 &&
        Shopify.PreviewBarInjector.length == 1
      ) {
        $indicator.text('Preview: ' + Shopify.theme.name).removeClass('hide');
        var events = {
          'click #responsive-indicator': function (e) {
            $indicator.toggleClass('active');
            $previewBar.toggleClass('active');
          }
        };

        _.extend(self.events, events);
        self.delegateEvents();
      } else {
        $indicator.addClass('hide');
      }
    }
  },
  handleRegionRestrictedAccess: async function () {
    var self = this;
    const addresses = await RechargeGateway.getAddresses();

    let userRegion = window.Shopify.country;
    if (addresses?.length) {
      const mostRecentAddress = addresses?.reduce((latest, current) => {
        return new Date(current.updated_at) > new Date(latest.updated_at)
          ? current
          : latest;
      });
      userRegion = mostRecentAddress.country_code;
    }

    self.redirectIfNotAllowedRegion(userRegion);
    self.hideLinksForNotAllowedRegions(userRegion);
  },

  redirectIfNotAllowedRegion: function (userRegion) {
    const pageToRedirect = '/';
    const allowedRegions =
      settings.page_metafield_allowed_regions?.trim() || '';

    const allowedRegionsArray = allowedRegions.length
      ? allowedRegions.split(',')
      : [];

    if (
      allowedRegionsArray.length > 0 &&
      !allowedRegionsArray.includes(userRegion)
    ) {
      window.location.href = pageToRedirect;
    }
  },

  hideLinksForNotAllowedRegions: function (userRegion) {
    const restrictedAccessLinks = document.querySelectorAll(
      '[data-allowed-regions]'
    );

    // delete links if not allowed for user region.
    restrictedAccessLinks.forEach((link) => {
      const allowedRegions =
        link.dataset.allowedRegions !== ''
          ? link.dataset.allowedRegions.split(',')
          : [];
      if (allowedRegions.length && !allowedRegions.includes(userRegion)) {
        link.remove();
      }
    });

    // delete parent links if no children
    document.querySelectorAll('.level-2.has-children').forEach((el) => {
      const sublinks = el.querySelector('.links');
      const navImgs = el.querySelector('.nav-images.second-level');
      if (sublinks?.children.length === 0 && navImgs?.children.length === 0) {
        el.remove();
      }
    });
  }
});
